import { Expose, Type } from "class-transformer";
import { DeviceModel } from "./device-model";

export class UserDevicesModel {
    @Expose()
    @Type(() => DeviceModel)
    userDevice: DeviceModel;

    @Expose()
    @Type(() => DeviceModel)
    userDeviceKidsApp: DeviceModel;
}